<template>
  <div class="area-index margin-l-20" >
    <div class="area-index-header margin-r-20 ">
      <!--      <el-select v-model="companyForm.district" placeholder="请选择" popper-class="money" @change="getAll()" class="margin-l-20">-->
      <!--        <el-option key="新余市" label="新余市" value="新余市"></el-option>-->
      <!--        <el-option key="分宜县" label="分宜县" value="分宜县"></el-option>-->
      <!--        <el-option key="渝水区" label="渝水区" value="渝水区"></el-option>-->
      <!--      </el-select>-->
      <el-select v-model="value" placeholder="请选择" @change="getAll" class="margin-l-20">
        <el-option v-for='item in typeList' :key="item.value" :label="item.value" :value="item.value" ></el-option>
      </el-select>
      <el-date-picker class="margin-l-20" v-model="endTime" type="month" placeholder="选择月" :clearable="false"
                      format="yyyy-MM" :picker-options="pickerOptions"
                      value-format="yyyy-MM" @change="getAll"></el-date-picker>
      <!--      <el-date-picker-->
      <!--        v-model="endTime"-->
      <!--        type="month"-->
      <!--        placeholder="选择日期">-->
      <!--      </el-date-picker>-->
      <!--        <el-cascader v-model="value" :options="options" @change="handleChange" class="areaChoose"></el-cascader>-->
    </div>
    <!--九江市宏观数据 -->
    <div class="block  margin-t-20">
      <!--      <el-carousel :interval="4000" height="270px" :autoplay="false" class="rotation"  ref="carousel" indicator-position="none">-->
      <!--        <el-carousel-item class="cursor-pointer">-->
      <el-card class="margin-b-20 text-left margin-r-20 area-total">
        <el-row class="margin-b-20 margin-r-20">
          <el-col :span="6">
            <div class="index-bg" style="background-color: #0AB1DE">
              <div style="float: left;margin-left: 20px">
                <div class="area-index-num ">{{total.money}}</div>
                <div class="index-span-p">当期网络零售额（万元）</div>
                <div class="index-span-yoy"> 同比{{total.moneyYoy}}%
                  <i :class="[total.moneyYoy >=0?'el-icon-top text-red font-weight':'el-icon-bottom text-green font-weight']"></i></div>
              </div>
              <div style="float: right">
                <div class="index-span-box">
                  <img src="../../assets/areaIndex-money.png" class="margin-t-20"/>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="index-bg" style="background-color: #EC897D">
              <div style="float: left;margin-left: 20px">
                <div class="area-index-num">{{total.ljMoney}}</div>
                <div class="index-span-p">累计网络零售额（万元）</div>
                <div class="index-span-yoy"> 同比{{total.ljMoneyYoy}}%
                  <i :class="[total.ljMoneyYoy >=0?'el-icon-top text-red font-weight':'el-icon-bottom text-green font-weight']"></i></div>
              </div>
              <div style="float: right">
                <div class="index-span-box">
                  <img src="../../assets/areaIndex-ljmoney.png" class=" margin-t-20"/>
                </div>
              </div>

            </div>
          </el-col>
          <el-col :span="6">
            <div class="index-bg" style="background-color: #8A9AF4">
              <div style="float: left;margin-left: 20px">
                <div class="area-index-num">{{total.sales}}</div>
                <div class="index-span-p">当期网络零售量（万件）</div>
                <div class="index-span-yoy"> 同比{{total.salesYoy}}%
                  <i :class="[total.salesYoy >=0?'el-icon-top text-red font-weight':'el-icon-bottom text-green font-weight']"></i></div>
              </div>
              <div style="float: right">
                <div class="index-span-box">
                  <img src="../../assets/areaIndex-sales.png" class=" margin-t-20"/>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="index-bg" style="background-color: #7DA2E4">
              <div style="float: left;margin-left: 20px">
                <div class="area-index-num">{{total.ljSales}}</div>
                <div class="index-span-p">累计网络零售量（万件）</div>
                <div class="index-span-yoy"> 同比{{total.ljSalesYoy}}%
                  <i :class="[total.ljSalesYoy >=0?'el-icon-top text-red font-weight':'el-icon-bottom text-green font-weight']"></i></div>
              </div>
              <div style="float: right">
                <div class="index-span-box">
                  <img src="../../assets/areaIndex-ljsales.png" class=" margin-t-20"/>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row class="margin-t-10 margin-r-20">
          <el-col :span="6">
            <div class="index-bg" style="background-color: #84D0AF">
              <div style="float: left;margin-left: 20px">
                <div class="area-index-num">{{total.ljNcMoney || '--'}}</div>
                <div class="index-span-p">农村累计网零（万元）</div>
                <div class="index-span-yoy"> 同比{{total.ljNcYoy}}%
                  <i :class="[total.ljNcYoy >=0?'el-icon-top text-red font-weight':'el-icon-bottom text-green font-weight']"></i></div>
              </div>
              <div style="float: right">
                <div class="index-span-box">
                  <img src="../../assets/areaIndex-ljnc.png" class=" margin-t-20"/>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="index-bg" style="background-color: #D8C477">
              <div style="float: left;margin-left: 20px">
                <div class="area-index-num">{{total.shopNum}}</div>
                <div class="index-span-p">电商店铺数（家）</div>
              </div>
              <div style="float: right">
                <div class="index-span-box">
                  <img src="../../assets/areaIndex-shopNum.png" class=" margin-t-20"/>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="index-bg" style="background-color: #C68DD4">
              <div style="float: left;margin-left: 20px">
                <div class="area-index-num">{{total.companyNum}}</div>
                <div class="index-span-p">电商企业数（家）</div>
              </div>
              <div style="float: right">
                <div class="index-span-box">
                  <img src="../../assets/areaIndex-companyNum.png" class=" margin-t-20"/>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="index-bg" style="background-color: #EAAF98">
              <div style="float: left;margin-left: 20px">
                <div class="area-index-num">{{total.ljMoneyRank}}</div>
                <div class="index-span-p">累计网络零售额排名</div>
              </div>
              <div style="float: right">
                <div class="index-span-box">
                  <img src="../../assets/areaIndex-ljrank.png" class=" margin-t-20"/>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-card>
      <!--        </el-carousel-item>-->
      <!--      </el-carousel>-->

    </div>


    <!--地图、商品类型店铺数占比 -->
    <el-row class="margin-t-20" v-if="this.value == '九江市'">
      <el-col :span="12" class="padding-r-20">
        <el-card>
          <chart ref="chart1" :options="orgOptions" autoresize class="width-z100"
                 style="height: 400px"></chart>
        </el-card>
      </el-col>
      <el-col :span="12" class="padding-r-20">
        <el-card>
          <chart ref="chart1" :options="typeOptions" autoresize class="width-z100"></chart>
        </el-card>
      </el-col>
    </el-row>
    <div class="margin-t-20">
      <el-row>
        <el-col :span="12" class="padding-r-20">
          <el-card>
            <chart ref="chart1" :options="moneyOptions" autoresize class="width-z100" style="height: 517px"></chart>
          </el-card>

        </el-col>
        <el-col :span="12" class="padding-r-20 industryRank">
          <el-card>
            <div slot="header" class="index-header text-left">
              <span class="index-header-title">实物行业排行</span>
            </div>
            <el-table :data="industryTable" width="460px" height="482px" stripe class="border-DEDEDE margin-b-20"
                      :default-sort="{prop: 'money', order: 'descending'}">
              <el-table-column type="index" label="排名" width="100" align="center"></el-table-column>
              <el-table-column prop="category" label="行业名称"></el-table-column>
              <el-table-column prop="money" label="销售额（万元）" align="center"></el-table-column>
            </el-table>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <!--指数分析 -->
<!--    <el-row class="margin-t-20" v-if="this.value == '九江市'">-->
<!--      <el-col :span="8" class="padding-r-20" style="height: 440px">-->
<!--        <el-card class="height-z100">-->
<!--          <p class="index-header-title">九江市电商发展指数</p>-->
<!--          <div class="text-center">-->
<!--            <div style="margin-top: 130px;">-->
<!--            <span v-for="num in zhishuDing" :class="[isNaN(num)?'otherClass':'numClass']">-->
<!--             {{num}}-->
<!--            </span>-->
<!--            </div>-->
<!--            <p class="font-12 font-12 text-left margin-t-80" style="color: gray;">注：-->
<!--              该指数为当地电商发展企业指数、电商发展产业指数、电商市场发展指数及电商地区发展指数等综合计算得出，数据来源为本平台监测数据及国家统计局、地方统计局等权威数据统计平台。</p>-->
<!--          </div>-->
<!--        </el-card>-->
<!--      </el-col>-->
<!--      <el-col :span="16" class="padding-r-20">-->
<!--        <el-card>-->
<!--          <chart ref="chart1" :options="indexOptions" autoresize class="width-z100"></chart>-->
<!--        </el-card>-->

<!--      </el-col>-->
<!--    </el-row>-->

  </div>

</template>

<script>
  export default {
    name: 'index',
    // 子组件接收参数的核心位置：
    props: ['parent_value'],//截止查询时间
    data() {
      return {
        endTime: '', //选择月份

        orgOptions: {},//地图图表
        total: {},//首页店铺企业等监测宏观数据
        patternOptions: {},//交易模式占比图
        typeOptions: {},//商品类型占比图
        platformOptions: {},//交易平台占比图
        personalShopTable: [],//个人店铺排行
        industryTable: [],//行业排行
        companyShopTable: [],//企业店铺榜
        value: "九江市",
        typeList: [{'value': '九江市'}, {'value': '柴桑区'}, {'value': '德安县'}, {'value': '都昌县'}, {'value': '共青城市'},
          {'value': '湖口县'}, {'value': '濂溪区'}, {'value': '庐山市'}, {'value': '彭泽县'}, {'value': '瑞昌市'}, {'value': '武宁县'},
          {'value': '修水县'}, {'value': '浔阳区'}, {'value': '永修县'}],
        goodsTable: [],//特色赣品网络零售额排行
        companyOptions: [],//江西省TOP企业
        goodsShopTable: [],//江西省赣品店铺排行
        goodsListTable: [],//江西省热销单品排行
        moneyOptions: {},//当期网络零售额走势
        categoryTable: [],//特色赣品网络零售排行
        platformComOptions: {},
        indexOptions: {},//指数图表
        areaIndexList: [],
        zhishuDing: [],//电商指数
        pickerOptions: {
          disabledDate: (time) => {
            // console.log(time.getMonth());
            let nowDate = new Date()
            let day = nowDate.getDate()
            nowDate.setDate(1);
            if (day > 14) {
              if (nowDate.getMonth() == 0) {
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear() - 1);
              } else {
                nowDate.setMonth(nowDate.getMonth() - 1);
              }
            } else {
              if (nowDate.getMonth() == 0) {
                nowDate.setMonth(10);
                nowDate.setFullYear(nowDate.getFullYear() - 1);
              } else if (nowDate.getMonth() == 1) {
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear() - 1);
              } else {
                nowDate.setMonth(nowDate.getMonth() - 2);
              }
            }
            if(time.getFullYear()<2020){
              nowDate.setFullYear(time.getFullYear()-1)
              // console.dir(nowDate)
            }return time > nowDate
          }
        },

        // testData:{name:'指数',value:89,list:[{name:'节点1',value:0.5,children:[{name:'节点1-1',value:0.5},{name:'节点1-2',value:0.5}]},
        //     {name:'节点2',value:0.5,children:[{name:'节点2-1',value:0.5},{name:'节点2-2',value:0.5}]},]}
        testData: [{id: '1', name: '指数', value: 0.5, pId: '0', x: 300, y: 200,}, {
          id: '2',
          name: '指数1',
          value: 0.5,
          pId: '1',
          x: 360,
          y: 280,
        }, {
          id: '3', name: '指数2', value: 0.5, pId: '1', x: 360,
          y: 280
        }, {id: '4', name: '指数1-1', value: 0.5, pId: '2', x: 360, y: 280}]

      }
    },
    created() {
      this.$emit('public_header', true)
      this.oneMonth()
      this.getHomeList()
      this.getAreaIndex()

    },
    methods: {
      getAll() {
        this.getAreaIndex()
        this.getHomeList()
      },
      //首页列表
      getHomeList() {
        this.$http.get(this.header + '/qyjc/home', {
          params: {
            times: this.endTime,
            city: this.value,
          }
        }).then(res => {
          if (res.data.code == 0) {
            this.personalShopTable = res.data.shopRank
            this.industryTable = res.data.spdlRank
            if (res.data.area_index) {
              this.total = res.data.area_index
            } else {
              this.total = {}
            }
            this.goodsTable = res.data.goods
            this.goodsShopTable = res.data.shop
            this.companyShopTable = res.data.companyShopRank
            this.goodsListTable = res.data.goods
            this.categoryTable = res.data.category

            //地图
            let mapData = []
            res.data.districtList.forEach((x, index) => {
              let cityNum = {
                name: x.city,
                value: x.absoulte_value_pro,
                yoy: x.absoulte_value_yoy,

              }
              mapData.push(cityNum)
            })
            //地图
            this.orgOptions = {
              title: {//图表标题
                text: '九江市网络零售全景',
                left: 'left',
                textStyle: {
                  color: '#313131',
                  fontSize: 16,
                  fontWeight: 300,
                  marginBottom: 10000
                },
              },
              tooltip: { // 鼠标悬浮
                backgroundColor: 'rgba(50,50,50,0.7)',
                trigger: 'item',
                formatter: function (e) {
                  let aa = e.name + '网络零售额' + '<br/>'
                  return aa + '同比：' + e.data.yoy + '%' + '<br/>' + '占比：' + e.value + '%'
                }
              },
              visualMap: {
                min: 0,
                max: 30,
                realtime: false,
                calculable: false,
                inRange: {
                  color: ['rgba(218,228,258,1)', 'rgba(143,176,245,1)', 'rgba(106, 88, 196, 1)']
                }
              },
              series: [
                {
                  name: '九江各地区数据统计',
                  type: 'map',
                  mapType: 'JJ', // 自定义扩展图表类型
                  label: {
                    normal: {
                      textStyle: {
                        fontSize: 12,
                        // color: 'grey'
                      }
                    }
                  },
                  itemStyle: {
                    normal: {label: {show: true}},
                    emphasis: {label: {show: true}, areaColor: 'beige'}
                  },
                  data: mapData
                }
              ]
            }
            //12个月网络零售额走势
            let moneyList = {xTime: [], yTotalMoney: [], simple: []}
            res.data.wlxs.forEach((y, index) => {
              moneyList.xTime.push(y.times)
              let yMoney = {
                value: y.absoulte_value,
                unit: '万元'
              }
              let xSimple = {
                value: y.absoulte_value_yoy,
                unit: '%'
              }
              moneyList.yTotalMoney.push(yMoney)
              moneyList.simple.push(xSimple)
            })
            let MoneyMin1 = this.moneyCalMin(moneyList.yTotalMoney), MoneyMin2 = this.moneyCalMin(moneyList.simple),
              MoneyMax1 = this.moneyCalMax(moneyList.yTotalMoney), MoneyMax2 = this.moneyCalMax(moneyList.simple)
            //近13个月网络零售额走势图表
            this.moneyOptions = {
              color: ['#7888ed', '#FB975B'],
              title: {//图表标题
                text: this.value + '当期网络零售额变化趋势',
                left: 'left',
                textStyle: {
                  color: '#313131',
                  fontSize: 16,
                  fontWeight: 300,
                  marginBottom: 10000
                },
              },
              tooltip: { // 鼠标悬浮
                backgroundColor: 'rgba(50,50,50,0.7)',
                trigger: 'item',
                formatter: function (e) {
                  return e.name + e.seriesName + '<br/>' + e.value + e.data.unit
                }
              },
              toolbox: { //图表工具箱
                feature: {
                  // dataView: {show: true, readOnly: false},
                  magicType: {show: true, type: ['line']},
                  restore: {show: true},
                  saveAsImage: {show: true}
                }
              },
              legend: {//图表说明  horizontal竖着显示vertical横显示
                orient: 'horizontal',
                y: 'bottom',
                // x: 'left',
                textStyle: {
                  color: '#666',
                  fontSize: 14
                },
                data: ['当期网络零售额', '同比']
              },
              xAxis: {
                type: 'category',
                data: moneyList.xTime,
                axisLine: {
                  lineStyle: {
                    color: '#666'
                  }
                }
              },
              yAxis: [
                {
                  type: 'value',
                  name: '万元',
                  axisLine: {
                    lineStyle: {
                      color: '#666'
                    }
                  },
                  min: MoneyMin1,
                  max: MoneyMax1,
                  splitNumber: 5,
                  interval: (MoneyMax1 - MoneyMin1) / 5
                }, {
                  type: 'value',
                  name: '%',
                  axisLine: {
                    lineStyle: {
                      color: '#666'
                    }
                  },
                  min: MoneyMin2,
                  max: MoneyMax2,
                  splitNumber: 5,
                  interval: (MoneyMax2 - MoneyMin2) / 5,

                }],
              series: [{
                name: '当期网络零售额',
                type: 'bar',
                barCategoryGap: '60%',
                barWidth: 20,
                itemStyle: {

                  emphasis: {
                    color: '#83bff6'
                  }
                },
                data: moneyList.yTotalMoney,
                smooth: true
              }, {
                name: '同比',
                type: 'line',
                yAxisIndex: 1,
                data: moneyList.simple,
              }]
            }
            //商品类型占比
            let goodTypeList = {xLegend: [], yCom: []}
            res.data.splxlist.forEach((y, index) => {
              goodTypeList.xLegend.push(y.absoulte_key)
              let yMoney = {
                value: y.absoulte_value_pro,
                name: y.absoulte_key
              }
              goodTypeList.yCom.push(yMoney)
            })
            //商品类型占比
            this.typeOptions = {
              title: {
                text: this.value + '商品类型店铺占比情况',
                x: 'left',
                textStyle: {
                  color: '#313131',
                  fontSize: 16,
                  fontWeight: 300,
                  bottom: 10,
                },
              },
              tooltip: {
                trigger: 'item',
                formatter: '{b} : {c}%'
              },
              legend: {
                x: 'center',
                y: 'bottom',
                textStyle: {
                  color: '#666',
                  fontSize: 14
                },
                data: goodTypeList.xLegend
              },
              calculable: true,
              series: [
                {
                  name: '半径模式',
                  type: 'pie',
                  radius: ['50%', '70%'],
                  // roseType: 'radius',
                  label: {
                    normal: {
                      show: false,
                      position: 'center'
                    },
                    emphasis: {
                      show: true,
                      textStyle: {
                        fontSize: '30',
                        fontWeight: 'bold',
                      }
                    }
                  },
                  lableLine: {
                    normal: {
                      show: false
                    },
                    emphasis: {
                      show: true
                    }
                  },
                  itemStyle: {
                    normal: {
                      color: function (params) {
                        var colorList = ['#587EC4', '#FEB16B']
                        return colorList[params.dataIndex % 2]
                      }
                    },

                  },
                  data: goodTypeList.yCom
                }
              ]
            }
            //交易模式占比
            let patternList = {xLegend: [], yCom: []}
            res.data.jymsList.forEach((y, index) => {
              patternList.xLegend.push(y.absoulte_key)
              let yMoney = {
                value: y.absoulte_value_pro,
                name: y.absoulte_key
              }
              patternList.yCom.push(yMoney)
            })
            //交易模式占比
            this.patternOptions = {
              title: {
                text: this.value + '交易模式累计占比',
                x: 'left',
                textStyle: {
                  color: '#313131',
                  fontSize: 16,
                  fontWeight: 300,
                  bottom: 10,
                },
              },
              tooltip: {
                trigger: 'item',
                formatter: '{b}占比 : {c}%'
              },
              legend: {
                x: 'center',
                y: 'bottom',
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                data: patternList.xLegend
              },
              calculable: true,
              series: [
                {
                  name: '半径模式',
                  type: 'pie',
                  radius: ['50%', '70%'],

                  label: {
                    normal: {
                      show: false,
                      position: 'center'
                    },
                    emphasis: {
                      show: true,
                      textStyle: {
                        fontSize: '30',
                        fontWeight: 'bold',
                      }
                      // formatter: "{a} <br/>{b}: {c} ({d}%)"
                    }
                  },
                  lableLine: {
                    normal: {
                      show: false
                    },
                    emphasis: {
                      show: true
                    }
                  },
                  itemStyle: {
                    normal: {
                      color: function (params) {
                        var colorList = ['#7888ed', '#09a8d2']
                        //  var colorList = ['red','blue'];
                        return colorList[params.dataIndex % 2]
                      }
                    },

                  },
                  data: patternList.yCom
                }
              ]
            }
            //平台占比
            let platformList = {xLegend: [], yCom: []}
            res.data.jyptList.forEach((y, index) => {
              platformList.xLegend.push(y.platform)
              let yMoney = {
                value: y.ljMoneyPro,
                name: y.platform
              }
              platformList.yCom.push(yMoney)
            })
            //平台占比
            this.platformOptions = {
              title: {
                text: this.value + '电商平台累计占比',
                x: 'left',
                textStyle: {
                  color: '#313131',
                  fontSize: 16,
                  fontWeight: 300,
                  bottom: 10,
                },
              },
              tooltip: {
                trigger: 'item',
                formatter: '{b}占比 : {c}%'
              },
              legend: {
                x: 'center',
                y: 'bottom',
                textStyle: {
                  color: '#666',
                  fontSize: 14
                },
                data: platformList.xLegend
              },
              calculable: true,
              series: [
                {
                  name: '半径模式',
                  type: 'pie',
                  radius: ['45%', '60%'],
                  center: ['50%', '36%'],
                  label: {
                    normal: {
                      show: false,
                      position: 'center'
                    },
                    emphasis: {
                      show: true,
                      textStyle: {
                        fontSize: '30',
                        fontWeight: 'bold',
                      }
                      // formatter: "{a} <br/>{b}: {c} ({d}%)"
                    }
                  },
                  lableLine: {
                    normal: {
                      show: false
                    },
                    emphasis: {
                      show: true
                    }
                  },
                  itemStyle: {
                    normal: {
                      color: function (params) {
                        let colorList = ['#8589e2', '#60D6CA', '#3fd6a3', '#F7AE4E', '#71CBC0', '#85B0FB', '#FFC4C6', '#4C8DFF', '#FF9F7F', '#FFDB5C', '#67E0E3', '#9FE6B8', '#32C5E9']
                        //  var colorList = ['red','blue'];
                        return colorList[params.dataIndex % 12]
                      }
                    },

                  },
                  data: platformList.yCom
                }
              ]
            }
          } else {
            this.$alert(res.data.msg)
          }

        })
      },
      //区域指数
      getAreaIndex() {
        this.$http.get(this.header + '/qyjc/areaIndex', {
          params: {
            times: this.endTime,
            //times: '2019-10'
          }
        }).then(res => {
          if (res.data.code == 0) {

            res.data.areaIndex.forEach(y => {
              if (y.level == 1) {
                y.symbolSize = 60
                y.draggable = true
              } else if (y.level == 2) {
                y.symbolSize = 50
              }

            })
            this.areaIndexList = res.data.areaIndex
            let zhishu = this.areaIndexList[0].value.toString()
            this.zhishuDing = []

            for (let i = 0; i < zhishu.length; i++) {
              let num = +zhishu.charAt(i)
              if (isNaN(num)) {
                num = '.'
              }
              this.zhishuDing.push(num);
              // console.log(isNaN(num))
            }
            let testList = []
            this.areaIndexList.forEach(x => {
              this.areaIndexList.forEach(y => {
                if (x.pid == y.id) {
                  let test = {
                    source: y.id,
                    target: x.id
                  }
                  testList.push(test)
                }
              })
            })
            this.indexOptions = {
              title: {
                text: '九江市电商发展指数关系图',
                x: 'left',
                textStyle: {
                  color: '#313131',
                  fontSize: 16,
                  fontWeight: 300,
                  bottom: 10,
                },
              },
              tooltip: {},
              animationDurationUpdate: 1500,
              animationEasingUpdate: 'quinticInOut',
              series: [
                {
                  type: 'graph',
                  layout: 'force',
                  symbolSize: 40,
                  roam: true,
                  label: {
                    normal: {
                      show: true,
                      // color:'#fff'
                    }
                  },
                  edgeSymbol: ['circle', 'arrow'],
                  edgeSymbolSize: [4, 10],
                  edgeLabel: {
                    normal: {
                      textStyle: {
                        fontSize: 16,
                        color: '#fff'
                      }
                    }
                  },
                  data: this.areaIndexList,

                  // links: [],
                  links: testList,
                  itemStyle: {
                    normal: {
                      // color:'#85B0FB',
                      color: function (params) {
                        let colorList = ['#8589E2', '#FFAF67', '#4EAFE1', '#57D4C5']
                        //  var colorList = ['red','blue'];
                        return colorList[params.dataIndex % 4]
                      }
                    }
                  },
                  lineStyle: {
                    normal: {
                      opacity: 0.9,
                      width: 2,
                      curveness: 0,
                      color: {
                        type: 'radial',
                        x: 0.5,
                        y: 0.5,
                        r: 0.5,
                        colorStops: [{
                          offset: 0, color: '#0AA3E1' // 0% 处的颜色
                        }, {
                          offset: 1, color: '#A870EB' // 100% 处的颜色
                        }],
                        global: false // 缺省为 false
                      }
                      // color: '#0AA3E1'
                    },

                  },
                  force: {
                    repulsion: 400,
                    gravity: 0.2,
                    edgeLength: [20, 80]
                  }
                },
              ]
            }
          } else {
            this.$alert(res.data.msg)
          }

        })
      },
      //当月网络零售额走势图表计算最大值
      moneyCalMax(arr) {
        let max = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (max < el1.value) {
              max = el1.value
            }
          }
          // })
        })
        let maxInt = Math.ceil(max / 9.5)//不让最高的值超过最上面的刻度
        let maxVal = maxInt * 10//让显示的刻度是整数
        return maxVal
      },

      //当月网络零售额走势图表计算最小值
      moneyCalMin(arr) {
        let min = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (min > el1.value) {
              min = el1.value
            }
          }
        })
        // })
        let minInt = Math.floor(min / 10)
        let minVal = minInt * 10//让显示的刻度是整数
        return minVal
      },
      //选择近1个月
      oneMonth(val) {
        let dataArr = []
        let data = new Date()
        let day = data.getDate()
        data.setMonth(data.getMonth() + 1, 1)//获取到当前月份,设置月份
        for (let i = 0; i < 3; i++) {
          data.setMonth(data.getMonth() - 1)//每次循环一次 月份值减1
          let m = data.getMonth() + 1
          m = m < 10 ? '0' + m : m
          dataArr.push(data.getFullYear() + '-' + (m))
        }
        if (day > 14) {
          this.endTime = dataArr[1]
        } else {
          this.endTime = dataArr[2]
        }

        // console.dir(dataArr)
      }
    }
  }

</script>

<style>

  .area-index .ganPin-index-data .el-col {
    height: 100px;
    margin-right: 30px;
    background-color: #2A3039;
    width: 380px;
    padding: 20px;
    color: #A9B5C7;
    margin-bottom: 30px;
  }

  .area-index .area-index-header {
    text-align: left;
    margin-bottom: 20px;
    height: 45px;
    line-height: 45px;
    background: white;
    /*border: 1px solid rgba(100, 156, 238, 0.4);*/
    box-shadow: 0px 6px 7px 4px rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    color: #6589C5;
  }
  .area-index .industryRank .el-card__header{
    padding: 10px 18px;
  }
  .area-index .industryRank .el-card__body{
    padding: 5px 20px;
  }
  .area-index .index-bg {
    background-size: 100% 100%;
    border-radius: 10px 10px 10px 10px;
    height: 110px;
    padding-top: 5px;
    width: 100%;
  }

  .area-index .area-index-header .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 120px;
  }

  .otherClass {
    width: 7px;
    height: 7px;
    font-size: 36px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);

    background: linear-gradient(0deg, #5e64b2 0%, #c3c6f2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .numClass {
    color: white;
    margin-right: 5px;
    width: 53px;
    height: 86px;
    font-size: 66px;
    background: linear-gradient(0deg, #5e64b2, #c3c6f2);
    border-radius: 6px;
    display: inline-block;
  }

  .area-index .area-index-header .el-date-editor input {
    height: 30px;
    width: 130px;
    background-color: rgba(255, 255, 255, 1) !important;
    /*border-radius: 25px;*/
    color: #6B7991 !important;
  }

  .area-index .area-index-header .areaChoose input {
    background: rgba(36, 46, 71, 0.3) !important;
    border: 1px solid rgba(255, 255, 255, 0.3);
    /*width: 115px;*/
    height: 27px;
    line-height: 27px;
  }

  .area-index .area-total p {
    color: #333333;
    font-size: 14px;
    /*font-weight: bold;*/
  }

  .area-index .area-index-num {
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    /*margin-top: 20px;*/
  }

  .area-index .index-span-box {
    width: 100%;
    margin-right: 20px;
    /*width: 100%;*/
    /*margin-top: -45px !important;*/
    background-size: 100% 100%;
    height: 55px;
  }

  .area-index .el-col-6 {
    /*border-left: 1px solid;*/
    border-image: linear-gradient(to bottom, #fff, #A8A8A8) 0.4 1;
    padding-left: 1%;
  }

  .ganPin-index .ganPin-index-data {
    overflow: hidden;
  }

  .ganPin-index .data-one {
    border: 2px solid #EC846B;
    border-radius: 4px;
    width: 62px;
    height: 62px;
    padding: 16px;
    color: #EC846B;
    font-size: 28px;
  }

  .area-index .index-span-p {
    color: white;
    margin-top: 10px;
  }

  .area-index .index-span-yoy {
    color: white;
    font-size: 14px;
    margin-top: 10px;
  }

  .ganPin-index .data-two {
    border: 2px solid #E3B367;
    border-radius: 4px;
    width: 62px;
    height: 62px;
    padding: 16px;
    color: #E3B367;
    font-size: 28px;
  }

  .ganPin-index .data-three {
    border: 2px solid #ABC471;
    border-radius: 4px;
    width: 62px;
    height: 62px;
    padding: 16px;
    color: #ABC471;
    font-size: 28px;
  }

  .ganPin-index .data-four {
    border: 2px solid #60BDDF;
    border-radius: 4px;
    width: 62px;
    height: 62px;
    padding: 16px;
    color: #60BDDF;
    font-size: 28px;
  }

  .area-index .index .topicOne {
    /*background: linear-gradient(225deg, rgba(255, 73, 65, 1), rgba(225, 7, 7, 1));*/
    background-color: #4270F2;
    border-radius: 50%;
    height: 25px;
    line-height: 25px;
    width: 25px;
    color: white;
    margin-top: 8px;
  }

  .area-index .index .topicTwo {
    background: cornflowerblue;
    border-radius: 50%;
    height: 25px;
    line-height: 25px;
    width: 25px;
    color: white;
    margin-top: 8px;
  }

  .area-index .index .topicThree {
    background: rgba(143, 176, 245, 1);
    border-radius: 50%;
    height: 25px;
    width: 25px;
    line-height: 25px;
    color: white;
    margin-top: 8px;
  }

  .area-index .index .topicOther {
    /*background: linear-gradient(225deg, rgba(255, 165, 81, 1), rgba(255, 135, 16, 1));*/
    background-color: #8A8A8A;
    border-radius: 50%;
    height: 25px;
    width: 25px;
    line-height: 25px;
    color: white;
    margin-top: 8px;
  }

  .area-index .el-select .el-input__inner {
    width: 130px;
    height: 30px;
    color: #6B7991 !important;
  }

  .area-index .index-header-title {
    /*font-weight: bold;*/
    margin-bottom: 10px;
    margin-top: 10px;
    color: #313131;
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/area/index.vue